import { getCurrentIntl } from 'i18n/util/currentIntl'
import { formatOccupantsShort } from 'lib/offer/occupancyUtils'
import { middleDotSeparatorMessage } from 'LuxKit/intl/separators'
import { pluralizeToString } from 'lib/string/pluralize'

export function getOccupancyText(rooms: Array<App.Occupants>, saleUnit?: string) {
  const intl = getCurrentIntl()
  const sep = intl.formatMessage(middleDotSeparatorMessage)
  let text = formatOccupantsShort(rooms)
  if (!!saleUnit && !!rooms.length) {
    text += ` ${sep} ${pluralizeToString(saleUnit, rooms.length)}`
  }
  return text
}

export function getBnblOccupancyText(numberOfRooms: number, saleUnit?: string) {
  if (!!saleUnit && !!numberOfRooms) {
    return pluralizeToString(saleUnit, numberOfRooms)
  }
}
